import { ShopfloorLayoutSpecEdge } from '../shopfloor-layout-spec-edge'

export class ShopfloorLayoutSpec {
  public static readonly EMPTY = new ShopfloorLayoutSpec('', '', [])

  constructor(
    public id: string,
    public facility: string,
    public edges: ShopfloorLayoutSpecEdge[]
  ) {}
}
